import { render, staticRenderFns } from "./General.vue?vue&type=template&id=ad1e176c&lang=pug"
import script from "./General.vue?vue&type=script&lang=ts"
export * from "./General.vue?vue&type=script&lang=ts"
import style0 from "./General.vue?vue&type=style&index=0&id=ad1e176c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports